var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-slots-container" },
    [
      _c(
        "div",
        {
          staticClass:
            "row paddingTop27px margin-top-25px background-color-table"
        },
        [
          _c("div", { staticClass: "col-md-5" }, [
            _vm.title === "Screeners"
              ? _c("div", { staticClass: "title-header" }, [
                  _vm._v("Biometric Screening")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title === "Slots"
              ? _c("div", { staticClass: "title-header" }, [
                  _vm.fluShot === 1
                    ? _c("div", [_vm._v("Flu Shot")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fluShot === 2
                    ? _c("div", [_vm._v("Covid Vaccine")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fluShot === 3
                    ? _c("div", [_vm._v("Covid & Flu Shots")])
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "block-open-wrapper group-btn" }, [
              _c(
                "button",
                {
                  staticClass: "ap-btn destructive",
                  on: {
                    click: function($event) {
                      _vm.blockOpenStaffing(true)
                    }
                  }
                },
                [_vm._v("Block all")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "ap-btn primary",
                  on: {
                    click: function($event) {
                      _vm.blockOpenStaffing(false)
                    }
                  }
                },
                [_vm._v("Open all")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-1" })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row number-slots-container" }, [
        _c("div", { staticClass: "col-md-12 number-slots-defautl" }, [
          _vm.title == "Screeners"
            ? _c("div", { staticClass: "col-md-12 for-screening body-text" }, [
                _c("p", { staticClass: "col-md-5" }, [
                  _vm._v("Screener Station (" + _vm._s(_vm.maxValueStaff) + ")")
                ]),
                _vm._v(" "),
                _vm.title == "Screeners"
                  ? _c(
                      "div",
                      { staticClass: "col-md-6 d-flex justify-content-end" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn-minus",
                            on: {
                              click: function($event) {
                                _vm.onAddOrRemoveScreener(false)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../../static/img/minus.svg"),
                                alt: "minus"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn-add",
                            on: {
                              click: function($event) {
                                _vm.onAddOrRemoveScreener(true)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../../static/img/add-icon.svg"),
                                alt: "add"
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-1" })
              ])
            : _c("div", { staticClass: " col-md-12 for-flu-shot" }, [
                _c("div", { staticClass: "slots-count body-text" }, [
                  _vm._v(
                    "Slots (" +
                      _vm._s(_vm.eventDetail.maxParticipantPerSlot) +
                      ")"
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ap-field-input-wrapper" }, [
                  _c("div", { staticClass: "ap-input-wrapper" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.eventDetail.maxParticipantPerSlot,
                          expression: "eventDetail.maxParticipantPerSlot"
                        }
                      ],
                      staticClass: "input body-text",
                      domProps: {
                        value: _vm.eventDetail.maxParticipantPerSlot
                      },
                      on: {
                        blur: _vm.updateCustomSlotFluShot,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.eventDetail,
                            "maxParticipantPerSlot",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row background-color-table" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "screener-table" }, [
            _c("div", { staticClass: "s-header" }, [
              _c("div", { staticClass: "s-header-wrapper" }, [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "s-container",
                      attrs: { id: "s-container-" + _vm.title }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "s-wrapper" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "icon-wrapper left",
                              on: {
                                click: function($event) {
                                  _vm.moveLeft()
                                }
                              }
                            },
                            [_c("div", { staticClass: "left-icon" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "icon-wrapper right",
                              on: {
                                click: function($event) {
                                  _vm.moveRight()
                                }
                              }
                            },
                            [_c("div", { staticClass: "right-icon" })]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticStyle: {
                              "min-width": "80px",
                              width: "80px",
                              float: "left",
                              height: "1px"
                            }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.numberColumn, function(
                            slotHeaderNumber,
                            index
                          ) {
                            return slotHeaderNumber > _vm.startColumn &&
                              slotHeaderNumber <=
                                _vm.startColumn + _vm.numberShowColumn
                              ? _c("div", { staticClass: "s-header-column" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "staffing-select-column",
                                      class:
                                        _vm.selectedColumns.indexOf(index) >= 0
                                          ? "always-show"
                                          : null
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "custom-checkbox custom-control"
                                        },
                                        [
                                          _c("input", {
                                            staticClass: "custom-control-input",
                                            attrs: {
                                              type: "checkbox",
                                              autocomplete: "off"
                                            },
                                            domProps: {
                                              checked:
                                                _vm.selectedColumns.indexOf(
                                                  index
                                                ) >= 0
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.toggleSelectColumn(
                                                  index,
                                                  _vm.slotsGroup
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass:
                                              "custom-control-indicator",
                                            attrs: { "aria-hidden": "true" }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass:
                                              "custom-control-description"
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(slotHeaderNumber) +
                                      "\n                  "
                                  )
                                ])
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "s-body" },
              _vm._l(_vm.slotsGroup, function(slotGroup, indexTime) {
                return _c("div", { staticClass: "s-body-row" }, [
                  _c("div", { staticClass: "row-wrapper" }, [
                    _c("div", { staticClass: "time-wrapper" }, [
                      _c("div", { staticClass: "s-body-time label-text" }, [
                        _c("span", {}, [_vm._v(_vm._s(slotGroup.timeString))])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "staffing-select-row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "custom-checkbox custom-control",
                            class:
                              _vm.selectedRows.indexOf(indexTime) >= 0
                                ? "always-show"
                                : null
                          },
                          [
                            _c("input", {
                              staticClass: "custom-control-input",
                              attrs: { type: "checkbox", autocomplete: "off" },
                              domProps: {
                                checked:
                                  _vm.selectedRows.indexOf(indexTime) >= 0
                              },
                              on: {
                                click: function($event) {
                                  _vm.toggleSelectRow(
                                    indexTime,
                                    slotGroup.eventSlots
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "custom-control-indicator",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "custom-control-description"
                            })
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "slot-wrapper" }, [
                      _c("div", { staticClass: "s-container" }, [
                        _c(
                          "div",
                          {
                            staticClass: "s-wrapper s-body-wrapper",
                            class:
                              _vm.selectedRows.indexOf(indexTime) >= 0
                                ? "selected-staffing-item"
                                : null
                          },
                          _vm._l(slotGroup.eventSlots, function(
                            eventSlot,
                            indexSlot
                          ) {
                            return indexSlot >= _vm.startColumn &&
                              indexSlot < _vm.startColumn + _vm.numberShowColumn
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "s-body-item",
                                    class:
                                      _vm.selectedItemIds.indexOf(
                                        eventSlot.id +
                                          "-" +
                                          eventSlot.screenerNumber
                                      ) >= 0
                                        ? "selected-staffing-item"
                                        : "un-selected-staffing-item"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "staffing-check",
                                        class:
                                          _vm.selectedItemIds.indexOf(
                                            eventSlot.id +
                                              "-" +
                                              eventSlot.screenerNumber
                                          ) >= 0
                                            ? "always-show"
                                            : null
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "custom-checkbox custom-control"
                                          },
                                          [
                                            _c("input", {
                                              staticClass:
                                                "custom-control-input",
                                              attrs: {
                                                type: "checkbox",
                                                autocomplete: "off"
                                              },
                                              domProps: {
                                                value: eventSlot.id,
                                                checked:
                                                  _vm.selectedItemIds.indexOf(
                                                    eventSlot.id +
                                                      "-" +
                                                      eventSlot.screenerNumber
                                                  ) >= 0
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.toggleSelect(eventSlot)
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "custom-control-indicator",
                                              attrs: { "aria-hidden": "true" }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "custom-control-description"
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    eventSlot.eventParticipants != null &&
                                    eventSlot.eventParticipants.length
                                      ? _c("div", {
                                          staticClass: "bullet green"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    eventSlot.eventParticipants != null &&
                                    eventSlot.eventParticipants.length
                                      ? _c("div", { staticClass: "text" }, [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                eventSlot.eventParticipants[0]
                                                  .firstName
                                              ) +
                                              " " +
                                              _vm._s(
                                                eventSlot.eventParticipants[0]
                                                  .lastName
                                              ) +
                                              "\n                      "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    eventSlot.status == "OPEN"
                                      ? _c("div", {
                                          staticClass: "bullet grey"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    eventSlot.status == "OPEN"
                                      ? _c("div", { staticClass: "text" }, [
                                          _vm._v(_vm._s(eventSlot.status))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    eventSlot.status == "BLOCKED"
                                      ? _c("div", { staticClass: "bullet red" })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    eventSlot.status == "BLOCKED"
                                      ? _c("div", { staticClass: "text" }, [
                                          _vm._v(_vm._s(eventSlot.status))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "action-btn" }, [
                                      _c("div", { staticClass: "dot" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "dot" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "dot" }),
                                      _vm._v(" "),
                                      _c("ul", { staticClass: "action-menu" }, [
                                        eventSlot.status !== "BOOKED"
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.blockOpenThisStaffing(
                                                      eventSlot
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      eventSlot.status ===
                                                        "BLOCKED"
                                                        ? "Open"
                                                        : "Block"
                                                    ) +
                                                    " slot\n                          "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        eventSlot.status === "BOOKED"
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.clearSingleSlot({
                                                      eventSlot: eventSlot,
                                                      index: {
                                                        time: indexTime,
                                                        slot: indexSlot
                                                      }
                                                    })
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            Clear slot\n                          "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        eventSlot.eventParticipants == null ||
                                        eventSlot.eventParticipants.length === 0
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.showPatientDetails()
                                                  }
                                                }
                                              },
                                              [_vm._v("Details")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        eventSlot.eventParticipants != null &&
                                        eventSlot.eventParticipants.length
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.showPatientDetails(
                                                      eventSlot
                                                        .eventParticipants[0]
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Details")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        eventSlot.status !== "BOOKED"
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.addParticipant(
                                                      eventSlot
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Add Participant")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        eventSlot.status === "BOOKED"
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.editParticipant(
                                                      eventSlot
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Edit Participant")]
                                            )
                                          : _vm._e()
                                      ])
                                    ])
                                  ]
                                )
                              : _vm._e()
                          })
                        )
                      ])
                    ])
                  ])
                ])
              })
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("PatientDetailModal"),
      _vm._v(" "),
      _c("AddParticipantModal", {
        attrs: { requestUpdateTable: _vm.requestUpdateTable }
      }),
      _vm._v(" "),
      _c("SearchParticipantModal", {
        attrs: { requestUpdateTable: _vm.requestUpdateTable }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-150c0a9d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-150c0a9d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slots/SlotsTable.vue
// module id = 1727
// module chunks = 1